import { shiftTypeSchema, type IShiftType } from "./shifts";
import { type IOrganization } from "./organizations";

// Which shift types each organization uses.
export const shiftTypesByOrganization: Record<IOrganization, IShiftType[]> = {
  medoma: [
    shiftTypeSchema.enum.Center,
    shiftTypeSchema.enum.InHouse,
    shiftTypeSchema.enum.Admin,
    shiftTypeSchema.enum.Introduction,
    shiftTypeSchema.enum.Doctor,
  ],
  qa: [
    shiftTypeSchema.enum.Center,
    shiftTypeSchema.enum.InHouse,
    shiftTypeSchema.enum.Admin,
    shiftTypeSchema.enum.Introduction,
    shiftTypeSchema.enum.Doctor,
  ],
  slso: [
    shiftTypeSchema.enum.Center,
    shiftTypeSchema.enum.InHouse,
    shiftTypeSchema.enum.Admin,
    shiftTypeSchema.enum.Introduction,
  ],
  ssh: [
    shiftTypeSchema.enum.Center,
    shiftTypeSchema.enum.InHouse,
    shiftTypeSchema.enum.Admin,
    shiftTypeSchema.enum.Introduction,
  ],
  capioahc: [
    shiftTypeSchema.enum.Center,
    shiftTypeSchema.enum.InHouse,
    shiftTypeSchema.enum.Admin,
    shiftTypeSchema.enum.Introduction,
  ],
  sus: [
    shiftTypeSchema.enum.Center,
    shiftTypeSchema.enum.InHouse,
    shiftTypeSchema.enum.Admin,
    shiftTypeSchema.enum.Introduction,
  ],
  rakus: [
    shiftTypeSchema.enum.Center,
    shiftTypeSchema.enum.InHouse,
    shiftTypeSchema.enum.Admin,
    shiftTypeSchema.enum.Introduction,
  ],
  hahag: [
    shiftTypeSchema.enum.Center,
    shiftTypeSchema.enum.InHouse,
    shiftTypeSchema.enum.Admin,
    shiftTypeSchema.enum.Introduction,
    shiftTypeSchema.enum.External,
  ],
  ksgr: [
    shiftTypeSchema.enum.Center,
    shiftTypeSchema.enum.InHouse,
    shiftTypeSchema.enum.Admin,
    shiftTypeSchema.enum.Introduction,
  ],
};
